import { v4, v5 } from 'uuid';

export const uuidv4 = v4;

export const uuidv5 = v5;

export const UUIDV4_REGEX = /[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}/i;
